import React, { useEffect, useState, useRef } from 'react';
import { Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { debounce, isEmpty, trim, filter, compact } from 'lodash';

import Search from '../../../../../../../components/uiComponent/inputs/searchinput';
import AntdAccordionCard from '../../../../../../../components/uiComponent/accordion';

import DisLikeIcon from '../../../../../../../assets/icons/dis-like.svg';

import { StepTwoWrapper, CollapseAbleCardWrapper } from '../../style';
import Card from './Card';
import MultiSkuDrawer from './MultiSkuDrawer';
import AddItemDrawer from './AddItemDrawer';
import AddSkuToPlanDrawer from './AddSkuToPlanDrawer';
import AccordionCardsData from './AccordionCardsData';
import ShipmentPallets from './ShipmentPallets';
import { Spin } from 'antd';
import Button from "../../../../../../../components/uiComponent/button/index";
import { GetPackingItems, ConfirmPackingOption } from '../../../../../../../slices/post-shipment';
import { GetOrderItems } from '../../../../../../../slices/work-orders';

const CollapseAbleCard = ({
  boxesList,
  setCreateMultiSKU,
  itemShipmentIndex,
  activeShipmentIndex,
  setDefaultTab,
  filteredBoxesList,
  boxCurrentPage,
  setBoxCurrentPage,
  isDataLoading
}) => {
  return (
    <CollapseAbleCardWrapper>
      <Spin spinning={isDataLoading}>
        <AntdAccordionCard
          cardsData={
            <AccordionCardsData
              boxesList={boxesList}
              setCreateMultiSKU={setCreateMultiSKU}
              itemShipmentIndex={itemShipmentIndex}
              activeShipmentIndex={activeShipmentIndex}
              setDefaultTab={setDefaultTab}
              filteredBoxesList={filteredBoxesList}
              boxCurrentPage={boxCurrentPage}
              setBoxCurrentPage={setBoxCurrentPage}
            />
          }
          title={`Boxes No (${filteredBoxesList?.length || 0})`}
        />
      </Spin>
    </CollapseAbleCardWrapper>
  )
};

const StepTwo = ({
  activeShipmentIndex,
  isSubmitPackingInfo,
  setShipmentsData,
  shipmentsData,
  setContactDetails,
  contactDetails,
  deletedPallets,
  setDeletedPallets,
  showTransportGlobal,
  setActiveKey,
  activeKey,
  setTransportationDetails,
  transportationDetails,
  updateShipmentTrackingDetailsLoading,
  deliveryWindowOptionsLoading,
  palletsChangeAllowed,
  setPalletsChangeAllowed,
  setIsSubmitPackingInfo,
  currentPage,
  setCurrentPage,
  shipmentType
}) => {
  const { workOrderId } = useParams();
  const dispatch = useDispatch();
  const [boxCurrentPage, setBoxCurrentPage] = useState(1);
  const inputRef = useRef(null);

  const [productInfo, setProductInfo] = useState(false);
  const [isCreateMultiSKU, setCreateMultiSKU] = useState(false);
  const [showAddSkuDrawer, setShowAddSkuDrawer] = useState(false);
  const [itemShipmentIndex, setItemShipmentIndex] = useState(0);
  const [productDetail, setProductDetail] = useState({});

  const [itemsList, setItemsList] = useState({ toBeBoxed: [], boxed: [] });
  const [itemIndex, setItemIndex] = useState(-1);
  const [activeTabKey, setActiveTabKey] = useState('1');
  const [itemShipments, setItemShipments] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [boxesList, setBoxesList] = useState([]);
  const [filteredBoxesList, setFilteredBoxesList] = useState([]);
  const [remainingItems, setRemainingItems] = useState([]);

  const { toBeBoxed, boxed } = itemsList || {};

  const {
    shipmentDetails,
    packingMethod,
    packingGroups,
    packingItems,
    fetchingPackingItems,
    packingOptions,
    packingOptionId,
    confirmingPackingOption,
    fetchingPackingGroups,
    packingBoxes,
    skuGroupMap,
    boxRequirements,
    fetchingWarehouseShipments,
    settingPackInformation,
  } = useSelector((state) => state.postShipment || {});

  const { inboundStatus } = shipmentDetails || {};

  const {
    orderItems = [],
    fetchingOrderItems,
  } = useSelector((state) => state.workOrders || {});

  const { currentUser } = useSelector((state) => state.auth || {});

  // packingGroupId for Pack Now box creation and queries
  const activeGroup = (activeShipmentIndex !== -1 && packingGroups?.[activeShipmentIndex]) ? packingGroups[activeShipmentIndex] : packingGroups?.[0];
  const packingGroupId = typeof activeGroup === 'string' ? activeGroup : activeGroup?.packingGroupId || null;

  const isDataLoading = packingMethod === 'pack_now' ? (fetchingPackingItems || fetchingOrderItems) : fetchingWarehouseShipments;

  // Pack Now: fetch work order items (by sku_id, boxed via packing group)
  useEffect(() => {
    if (packingMethod === 'pack_now') {
      dispatch(GetPackingItems({ workOrderId }));
      dispatch(GetOrderItems({ workOrderId, page: { pageSize: 1000, pageNumber: 1 } }));
    }
  }, [packingMethod, workOrderId, packingOptionId, packingGroupId]);

  // Update item and box lists from either shipmentDetails (Pack Later) or packingItems/Boxes (Pack Now)
  useEffect(() => {
    const isPackNow = packingMethod === 'pack_now';
    
    if (!isPackNow && isEmpty(shipmentDetails)) return;

    const allShipmentItems = (isPackNow && activeShipmentIndex !== -1) ?
      (packingItems || []).filter(item => skuGroupMap && skuGroupMap[item.msku] === packingGroups[activeShipmentIndex]?.packingGroupId) :
      (isPackNow ? (packingItems || []) : (activeShipmentIndex === -1) ?
        (shipmentDetails?.shipments?.map(shipment => shipment.shipment_items_info)?.flat() || []) :
        (shipmentDetails?.shipments[activeShipmentIndex].shipment_items_info || []));
      
    const allShipmentItemsEnriched = allShipmentItems.map(item => {
        const details = orderItems.find(p => 
          (p.sku && item.msku && p.sku === item.msku) || 
          (p.msku && item.msku && p.msku === item.msku) || 
          (p.sku_id && item.sku_id && p.sku_id === item.sku_id)
        );
        const product_details = details?.products_v2 || details?.product_details || item?.product_details || [];
        const asin = details?.asin || details?.vendorasin?.asin || item?.asin;
        return { ...item, product_details, asin };
      });

    const allBoxes = (isPackNow && activeShipmentIndex !== -1) ?
      (packingBoxes || []).filter(box => box.packing_group_id === packingGroups[activeShipmentIndex]?.packingGroupId) :
      (isPackNow ? (packingBoxes || []) : (activeShipmentIndex === -1) ?
        (shipmentDetails?.shipments?.map(shipment => shipment.boxes_info)?.flat() || []) :
        (shipmentDetails?.shipments[activeShipmentIndex].boxes_info || []));
      
    const toBeBoxed = [...(allShipmentItemsEnriched || [])]
      .sort((a, b) => (Number(a?.boxed_quantity || 0) === Number(a?.quantity || 0) ? 1 : -1));

    const remainingItems = (allShipmentItemsEnriched || []).filter(
      item => item && Number(item.boxed_quantity || 0) !== Number(item.quantity || 0)
    );

    setRemainingItems(remainingItems);

    const boxed = (allShipmentItemsEnriched || []).filter(item => {
      if (!item) return false;
      const { boxed_quantity = 0, quantity } = item;
      return Number(boxed_quantity) === Number(quantity || 0) && Number(quantity) > 0;
    });

    setActiveTabKey('1');
    setItemsList({ toBeBoxed, boxed });
    setFilteredItems(toBeBoxed);
    setBoxesList(compact(allBoxes));
    inputRef?.current?.value && (inputRef.current.value = '');
  }, [shipmentDetails, activeShipmentIndex, packingMethod, packingBoxes, packingItems, orderItems]);

  useEffect(() => {
    setFilteredBoxesList(boxesList);
  }, [boxesList]);

  const handleSearch = debounce(({ target }) => {
    const { value } = target || {};

    if (trim(value)) {
      const data = (activeTabKey == '1') ? toBeBoxed : boxed;

      const filteredData = filter(data, item =>
        item?.fnsku?.toLowerCase().includes(value.toLowerCase()) ||
        item?.item_name?.toLowerCase().includes(value.toLowerCase()) ||
        item?.msku?.toLowerCase().includes(value.toLowerCase()) ||
        (item?.product_details || []).some(product =>
          product.identifier_value?.toLowerCase().includes(value.toLowerCase())
        )
      ) || [];

      if (filteredData?.length) {
        setItemIndex(0);

        if (packingMethod !== 'pack_now') {
          const filteredShipments = (activeShipmentIndex === -1
            ? shipmentDetails.shipments
            : [shipmentDetails.shipments[activeShipmentIndex]]
          ).filter(({ shipment_items_info }) =>
            shipment_items_info?.some(({ msku }) => msku === filteredData[0].msku)
          )?.map(({ shipment_items_info, boxes_info, ...rest }) => {
            // shipment_item_id is required to pack — the search path was dropping it,
            // which left the modal with no shipment_item_id ("Refusing to pack").
            const { boxed_quantity = 0, quantity = 0, id: shipment_item_id } = shipment_items_info?.find(({ msku }) => msku === filteredData[0].msku) || {};
            return { ...rest, boxed_quantity, quantity, shipment_item_id };
          }) || [];

          setItemShipments(filteredShipments);

          // Always resolve a valid itemShipmentIndex (never -1) so the opened modal can pack.
          const availableShipmentIndex = filteredShipments.findIndex(
            ({ quantity, boxed_quantity }) => (Number(quantity) || 0) - (boxed_quantity || 0) >= 0
          );
          if (activeShipmentIndex === -1) {
            setItemShipmentIndex(availableShipmentIndex === -1 ? 0 : availableShipmentIndex);
          } else {
            const { amazon_shipment_id } = shipmentDetails?.shipments[activeShipmentIndex] || {};
            const idx = filteredShipments.findIndex((shipment) => shipment?.amazon_shipment_id === amazon_shipment_id);
            setItemShipmentIndex(idx === -1 ? Math.max(0, availableShipmentIndex) : idx);
          }
        }
      }

      setFilteredItems(filteredData);
      if (filteredData?.length === 1) {
        setProductDetail(filteredData[0]);
        setProductInfo(true);
      }

      if (packingMethod !== 'pack_now') {
        const filteredBoxList = boxesList.filter(box =>
          (box?.items || []).some(item =>
            filteredData.some(filteredItem => item.shipment_item_id === filteredItem.id)
          )
        );
        setFilteredBoxesList(filteredBoxList);
      }

    } else {
      const defaultData = (activeTabKey == '1') ? toBeBoxed : boxed;
      setFilteredItems(defaultData);
      setFilteredBoxesList(boxesList);
    }
  }, 800);


  const isPackNow = packingMethod === 'pack_now';
  const showPackingOptions = isPackNow && activeKey === '1' && !packingOptionId;

  const handleConfirmPackingOption = (optionId) => {
    const selectedOption = packingOptions.find(opt => opt.packingOptionId === optionId);
    const groupId = selectedOption?.packingGroups?.[0]?.packingGroupId || null;
    dispatch(ConfirmPackingOption({ 
      workOrderId: Number(workOrderId), 
      packingOptionId: optionId,
      packingGroupId: groupId
    }));
  };

  if (showPackingOptions) {
    return (
      <StepTwoWrapper style={{ display: 'flex', flexDirection: 'column', padding: '24px', background: '#fff', borderRadius: '8px', border: '1px solid #ECEFF1' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '24px', color: '#212A2F' }}>Select a Packing Option</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
          {packingOptions.map((option, idx) => (
            <div 
              key={option.packingOptionId}
              style={{ border: '1px solid #ECEFF1', borderRadius: '8px', padding: '20px', background: '#F8FAFB', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
            >
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#1565D8' }}>Option {idx + 1}</h3>
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ marginBottom: '12px' }}>
                    <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#4E5969' }}><strong>Packing Groups:</strong> {option.packingGroups?.length || 0}</p>
                    {option.packingGroups?.map((group, groupIdx) => (
                      <div key={group.packingGroupId} style={{ marginBottom: '12px', padding: '10px', background: '#fff', borderRadius: '6px', border: '1px solid #ECEFF1' }}>
                        <p style={{ margin: '0 0 4px 0', fontSize: '13px', fontWeight: '600', color: '#212A2F' }}>Group {groupIdx + 1}</p>
                        <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '12px', color: '#4E5969', lineHeight: '1.6' }}>
                          {group.items?.slice(0, 5).map(item => (
                            <li key={item.msku}><strong>{item.msku}:</strong> {item.quantity} units</li>
                          ))}
                          {group.items?.length > 5 && <li style={{ listStyleType: 'none', color: '#1565D8', fontWeight: '500', marginTop: '4px' }}>+ {group.items.length - 5} more items</li>}
                        </ul>
                      </div>
                    ))}
                  </div>
                  {option.fees?.map(fee => (
                    <p key={fee.type} style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#4E5969' }}>
                      <strong>{fee.type}:</strong> {fee.amount?.currency} {fee.amount?.value}
                    </p>
                  ))}
                </div>
              </div>
              <Button 
                text="Confirm Option"
                onClick={() => handleConfirmPackingOption(option.packingOptionId)}
                loading={confirmingPackingOption}
              />
            </div>
          ))}
        </div>
        {fetchingPackingGroups && (
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Spin tip="Generating packing options..." />
          </div>
        )}
        {!fetchingPackingGroups && packingOptions.length === 0 && (
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
          
          </div>
        )}
      </StepTwoWrapper>
    );
  }

  return (
    <>
      {!isSubmitPackingInfo && activeKey !== '3'
      ?
      <StepTwoWrapper>
      
        <div className='items'>
          <header>
            <div className='actions'>
              <Search inputRef={inputRef} placeholder="Search by Title, SKU, UPC, FNSKU" className="search-ui-wrapper" onChange={handleSearch} />
              <Tooltip title='Scan'>
                <img src={DisLikeIcon} alt="dis-like-icon" onClick={() => inputRef?.current?.focus()} />
              </Tooltip>
              {isPackNow && currentUser?.role_id === 5 && (
                <Button
                  text="Add SKU"
                  className="outlined"
                  onClick={() => setShowAddSkuDrawer(true)}
                  disabled={inboundStatus === 'PACKED'}
                  style={{ marginLeft: 8 }}
                />
              )}
            </div>
          </header>
          <Spin spinning={isDataLoading}>
            <Card
              pagination={true}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              cardData={filteredItems}
              setProductInfo={setProductInfo}
              setItemIndex={setItemIndex}
              setItemShipments={setItemShipments}
              activeShipmentIndex={activeShipmentIndex}
              setItemShipmentIndex={setItemShipmentIndex}
              setProductDetail={setProductDetail}
              packingMethod={packingMethod}
              skuGroupMap={skuGroupMap}
            />
          </Spin>
        </div>
        <CollapseAbleCard
          boxesList={boxesList}
          setCreateMultiSKU={setCreateMultiSKU}
          itemShipmentIndex={itemShipmentIndex}
          activeShipmentIndex={activeShipmentIndex}
          setDefaultTab={() => setActiveTabKey('1')}
          filteredBoxesList={filteredBoxesList}
          boxCurrentPage={boxCurrentPage}
          setBoxCurrentPage={setBoxCurrentPage}
          isDataLoading={isDataLoading}
        />
      </StepTwoWrapper>
      :
        <ShipmentPallets
          contactDetails={contactDetails}
          setContactDetails={setContactDetails}
          shipmentsData={shipmentsData}
          setShipmentsData={setShipmentsData}
          deletedPallets={deletedPallets}
          setDeletedPallets={setDeletedPallets}
          setActiveKey={setActiveKey}
          activeKey={activeKey}
          showTransportGlobal={showTransportGlobal}
          setIsSubmitPackingInfo={setIsSubmitPackingInfo}
          setPalletsChangeAllowed={setPalletsChangeAllowed}
          palletsChangeAllowed={palletsChangeAllowed}
          deliveryWindowOptionsLoading={deliveryWindowOptionsLoading}
          updateShipmentTrackingDetailsLoading={updateShipmentTrackingDetailsLoading}
          setTransportationDetails={setTransportationDetails}
          transportationDetails={transportationDetails}
        />}

      {isPackNow && currentUser?.role_id === 5 && (
        <AddSkuToPlanDrawer
          open={showAddSkuDrawer}
          onClose={() => setShowAddSkuDrawer(false)}
          packingMethod={packingMethod}
          shipmentType={shipmentType}
        />
      )}

      {
        isCreateMultiSKU &&
        <MultiSkuDrawer
          isCreateMultiSKU={isCreateMultiSKU}
          setCreateMultiSKU={setCreateMultiSKU}
          toBeBoxed={remainingItems}
          activeShipmentIndex={activeShipmentIndex}
          boxesList={boxesList}
          packingGroupId={packingGroupId}
          packingMethod={packingMethod}
        />
      }

      {
        productInfo &&
        <AddItemDrawer
          clearSearch={() => inputRef.current.value = ''}
          setProductInfo={setProductInfo}
          productInfo={productInfo}
          itemsList={filteredItems}
          itemShipmentIndex={itemShipmentIndex}
          setItemShipmentIndex={setItemShipmentIndex}
          itemShipments={itemShipments}
          setItemShipments={setItemShipments}
          itemIndex={itemIndex}
          setItemIndex={setItemIndex}
          boxesList={boxesList}
          productDetail={productDetail}
          setProductDetail={setProductDetail}
          packingGroupId={packingGroupId}
          packingMethod={packingMethod}
          skuGroupMap={skuGroupMap}
          boxRequirements={boxRequirements}
          onBoxCreated={() => {
              dispatch(GetPackingItems({ workOrderId }));
          }}
        />
      }
    </>
  )
}

export default StepTwo
